import api from 'config/Api/Api';
import { formatFormDataBody } from 'utils';

const baseEndpoint = 'v1/account-direct-dial';

export default {
  getDdis( params ) {
    return api.get( baseEndpoint, params );
  },

  getDdi( id ) {
    return api.get( `${baseEndpoint}/${id}` );
  },

  updateDdi( id, data ) {
    return api.put( `${baseEndpoint}/${id}`, data );
  },

  deleteDdi( id ) {
    return api.delete( `${baseEndpoint}/${id}` );
  },

  saveMediaAudio( id, data ) {
    return api.post( `${baseEndpoint}/${id}/media-audio`, formatFormDataBody( data ) );
  },

  saveFavouriteAudio( id, data ) {
    return api.post( `${baseEndpoint}/${id}/favourite-media-audio`, data );
  },
};
